<section class="mx-auto max-w-[1200px] px-6 py-9">
  <div class="mb-6">
    <div class="flex gap-[3px] w-[30px] h-[4px] mb-2.5">
      <div class="flex-1 bg-(--cmr-vert)"></div>
      <div class="flex-1 bg-(--cmr-rouge)"></div>
      <div class="flex-1 bg-(--cmr-jaune)"></div>
    </div>
    <div class="text-[12px] font-bold uppercase tracking-[0.12em] text-(--text-muted)">{{ 'pages.startupsTpme.eyebrow' | translate }}</div>
    <h1 class="mt-2 mb-6 text-[30px] font-extrabold">{{ 'pages.startupsTpme.title' | translate }}</h1>

    @if (isAuthenticated()) {
      <div class="mb-5 grid gap-3 md:grid-cols-3">
        <label class="flex flex-col gap-1.5 text-[13px] font-bold text-(--text-muted)">
          <span>{{ 'pages.startupsTpme.region' | translate }}</span>
          <select [value]="regionFilter()" (change)="setRegionFilter($any($event.target).value)"
            class="h-10 rounded-md border border-(--border-strong) bg-white px-3 text-[13.5px] font-semibold text-(--text-body) outline-none focus:border-(--brand-primary)">
            <option value="">{{ 'opportunities.allTypes' | translate }}</option>
            @for (code of regionOptions; track code) {
              <option [value]="code">{{ ('regions.' + code) | translate }}</option>
            }
          </select>
        </label>

        <label class="flex flex-col gap-1.5 text-[13px] font-bold text-(--text-muted)">
          <span>{{ 'pages.startupsTpme.sector' | translate }}</span>
          <select [value]="sectorFilter()" (change)="setSectorFilter($any($event.target).value)"
            class="h-10 rounded-md border border-(--border-strong) bg-white px-3 text-[13.5px] font-semibold text-(--text-body) outline-none focus:border-(--brand-primary)">
            <option value="">{{ 'opportunities.allTypes' | translate }}</option>
            @for (code of sectorOptions; track code) {
              <option [value]="code">{{ ('sectors.' + code) | translate }}</option>
            }
          </select>
        </label>

        <label class="flex flex-col gap-1.5 text-[13px] font-bold text-(--text-muted)">
          <span>{{ 'pages.startupsTpme.need' | translate }}</span>
          <select [value]="needFilter()" (change)="setNeedFilter($any($event.target).value)"
            class="h-10 rounded-md border border-(--border-strong) bg-white px-3 text-[13.5px] font-semibold text-(--text-body) outline-none focus:border-(--brand-primary)">
            <option value="">{{ 'opportunities.allTypes' | translate }}</option>
            @for (code of needOptions; track code) {
              <option [value]="code">{{ ('needs.' + code) | translate }}</option>
            }
          </select>
        </label>
      </div>
    }
  </div>

  @if (!isAuthenticated()) {
    <div class="box-border rounded-md border border-(--border-subtle) bg-white px-6 py-16 text-center shadow-(--shadow-card)">
      <h2 class="m-0 mb-2 text-[18px] font-extrabold text-(--marine)">{{ 'pages.startupsTpme.loginToExplore' | translate }}</h2>
      <p class="m-0 mx-auto mb-5 max-w-md text-[13.5px] leading-relaxed text-(--text-muted)">
        {{ 'pages.startupsTpme.loginRequired' | translate }}
      </p>
      <button type="button" (click)="goToLogin()"
        class="box-border inline-flex h-11 cursor-pointer items-center justify-center rounded-sm border-0 bg-(--brand-primary) px-6 text-[14px] font-bold text-white transition-colors hover:bg-(--brand-primary-hover)">
        {{ 'nav.login' | translate }}
      </button>
    </div>
  } @else if (loading()) {
    <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'common.loading' | translate }}</p>
  } @else if (error()) {
    <p class="py-12 text-center text-[13.5px] text-(--state-danger)" role="alert">{{ 'pages.startupsTpme.loadError' | translate }}</p>
  } @else if (filteredResults().length > 0) {
    <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      @for (profile of paginatedResults(); track profile.id; let i = $index) {
        <a [appScrollReveal]="i" [routerLink]="['/organizations', profile.id]"
          class="block cursor-pointer rounded-[8px] border border-(--border-subtle) bg-white p-5 no-underline shadow-card transition duration-[200ms] ease-(--ease-standard) hover:-translate-y-1 hover:shadow-(--shadow-raised)">
          <div class="mb-3 flex items-center gap-3">
            <div class="flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-[8px] text-[17px] font-extrabold text-white" [style.background]="colorFor(profile)">
              {{ initials(organizationName(profile)) }}
            </div>
            <div class="min-w-0">
              <div class="truncate text-[15.5px] font-extrabold text-(--marine)">{{ organizationName(profile) }}</div>
              <div class="text-[12.5px] text-(--text-muted)">
                {{ profile.city }}@if (profile.city && regionLabelKey(profile.regionCode)) { , } {{ (regionLabelKey(profile.regionCode)) | translate }}
              </div>
            </div>
          </div>
          @if (description(profile); as text) {
            <p class="mb-3 text-[13px] leading-[1.55] text-(--text-muted)">{{ text }}</p>
          }
          @if (profile.organizationProfile?.sectorCode; as sectorCode) {
            <span class="inline-flex items-center rounded-(--radius-sm) border border-(--border-strong) bg-white px-3 py-[7px] text-[13.5px] font-semibold text-(--text-body)">
              {{ (sectorLabelKey(sectorCode) ?? '') | translate }}
            </span>
          }
        </a>
      }
    </div>

    @if (filteredResults().length > pageSize) {
      <div class="mt-6 flex flex-wrap items-center justify-end gap-2">
        <button type="button"
          class="cursor-pointer rounded-full border border-(--border-strong) bg-white px-3.5 py-2 text-[13px] font-bold text-(--text-muted) disabled:cursor-not-allowed disabled:opacity-50"
          [disabled]="currentPage() === 0"
          (click)="setPage(currentPage() - 1)">
          {{ 'common.previous' | translate }}
        </button>
        <span class="text-[13px] text-(--text-muted)" aria-live="polite">
          {{ 'events.list.pageOf' | translate: { page: currentPage() + 1, total: totalPages() } }}
        </span>
        <button type="button"
          class="cursor-pointer rounded-full border border-(--border-strong) bg-white px-3.5 py-2 text-[13px] font-bold text-(--text-muted) disabled:cursor-not-allowed disabled:opacity-50"
          [disabled]="currentPage() >= totalPages() - 1"
          (click)="setPage(currentPage() + 1)">
          {{ 'common.next' | translate }}
        </button>
      </div>
    }
  } @else {
    <div class="box-border rounded-md border border-(--border-subtle) bg-white px-6 py-16 text-center shadow-(--shadow-card)">
      <p class="m-0 text-[13.5px] text-(--text-muted)">{{ 'pages.startupsTpme.noResults' | translate }}</p>
      <button type="button" (click)="resetFilters()" class="mt-3 cursor-pointer border-0 bg-transparent text-[13.5px] font-bold text-(--pnud-bleu) hover:underline">
        {{ 'events.list.reset' | translate }}
      </button>
    </div>
  }
</section>
